#import "../fragments/edition-stub-fragment.graphql"

mutation DuplicateEdition($edition: EditionDuplicateToNewsletterEditionInput!) {
    editionDuplicateToNewsletterEdition(input: $edition) {
        edition {
            ...EditionStubFragment
        }
    }
}
